import { Component, OnInit } from '@angular/core';
import {ReminderService} from '../../services/reminder.service';

@Component({
  selector: 'app-archives',
  templateUrl: './archives.component.html',
  styleUrls: ['./archives.component.css']
})
export class ArchivesComponent implements OnInit {
  public reminders = [];
  constructor(private reminderService: ReminderService) { }

  ngOnInit(): void {
    this.getListOfReminder();
  }
  getListOfReminder(): any{
    this.reminderService.reminderList().subscribe(
      (data) => {
        this.reminders = data.data;
      }
    );
  }
}
